import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7876a2fa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7876a2fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7876a2fa')) {
      api.createRecord('7876a2fa', component.options)
    } else {
      api.reload('7876a2fa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7876a2fa&scoped=true", function () {
      api.rerender('7876a2fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/sign/weekly/index.vue"
export default component.exports